import React from 'react';
import { IProps } from './type';

const FacebookIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      width="19"
      height="27"
      viewBox="0 0 19 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12.1835 26.8217V15.0224H17.4904L18.2849 10.424H12.1835V7.48809C12.1835 6.15679 12.6789 5.24943 15.2372 5.24943L18.5 5.2483V1.13559C17.9355 1.07975 15.9988 0.95459 13.7456 0.95459C9.04132 0.95459 5.82069 3.09745 5.82069 7.03292V10.4241H0.5V15.0225H5.82052V26.8218L12.1835 26.8217Z" fill="#3D63B3" />
    </svg>
  )
};

export default FacebookIcon;
